import HorizontalSlideNavi from '../../component/navi/HorizontalSlideNavi';
import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class ServiceShortcut {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window
    }, options);

    // import Dragdealer
    _.Dragdealer = require('../../vendor/dragdealer-v0.9.8/dragdealer');

    _.global = (_.option.global) ? _.option.global : window;

    _.slideNavi = null;
  }

  init(obj) {
    const _ = this;

    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setSlideNavi();

    $(_.global).on('resize', $.proxy(_.resize, _));

    _.resize();
  }

  setSlideNavi() {
    const _ = this,
      slideNaviWrap = $(_.option.wrap),
      btnsWrap = $('.btns', slideNaviWrap);

    _.slideNavi = new HorizontalSlideNavi({
      Dragdealer: _.Dragdealer,

      // Navi.js options
      btns: $('li a', btnsWrap),

      clickCallback: function (obj) {
        if (!obj || !obj.btn) return;

        const btn = $(obj.btn),
          href = btn.attr('href'),
          target = btn.attr('target') || '_self';

        if (!href) return;
        window.open(href, target);
      },

      activateCallback: function (obj) {
        let btns = $(_.slideNavi.getBtns()),
          btn = $(_.slideNavi.getBtn(obj.index));

        btns.removeClass('on');
        btn.addClass('on');
      },

      // HorizontalSlideNavi.js options
      wrap: slideNaviWrap,
      handleClass: 'handle',
      btnsWrap: btnsWrap
    }).init();
  }

  destroySlideNavi() {
    const _ = this;

    if (isNotDefined(_.slideNavi)) return;

    _.slideNavi.destroy();
    _.slideNavi = null;

    // remove handle's css maked by Dragdealer.
    const handle = $('.handle', _.option.wrap);
    handle.css({
      '-webkit-transform': 'translateY(0)',
      '-moz-transform': 'translateY(0)',
      '-ms-transform': 'translateY(0)',
      '-o-transform': 'translateY(0)',
      'transform': 'translateY(0)',

      'perspective': '',
      'backface-visibility': ''
    });
  }

  resizeList(breakpoint) {
    const _ = this,
     list = $('.btns', _.option.wrap);
    let listSize;

    if(breakpoint === 'pc' ){
      listSize = list.children(':visible:not(".only-mobile")').length;
    } else {
      listSize = list.children(':visible:not(".only-pc")').length;
    }



    list.children('li').css({'width':'calc(100%/'+ listSize +')'});

  }

  resize(evt) {
    const _ = this,
      breakpoint = _.option.breakpoint;

    if (breakpoint.max && _.global.innerWidth >= breakpoint.max) {
      _.destroySlideNavi();
      _.resizeList('pc');

    } else if (breakpoint.pc && _.global.innerWidth >= breakpoint.pc) {
      _.destroySlideNavi();
      _.resizeList('pc');

    } else if (breakpoint.tablet && _.global.innerWidth >= breakpoint.tablet) {
      _.destroySlideNavi();
      _.resizeList('mobile');

    } else {
      if (!_.slideNavi) _.setSlideNavi();
      _.resizeList('mobile');
    }


  }
}

export default ServiceShortcut;


// WEBPACK FOOTER //
// ./_src/js/main/serviceShortcut/ServiceShortcut.js